import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsReportsTemplateRoute: InvariantJiraRoute = {
	name: 'assets-reports',
	path: '/jira/assets/reports/:templateId',
	exact: true,
};
